var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('dv-decoration-8',{staticClass:"header-left-decoration"}),_c('dv-decoration-5',{staticClass:"header-center-decoration"}),_c('dv-decoration-8',{staticClass:"header-right-decoration",attrs:{"reverse":true}}),_c('div',{staticClass:"center-title"},[_vm._v(_vm._s(_vm.appName)+"综合数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }